import { Text, VStack } from '@squire/ui';

import { styles } from './styles';
import type { LegalAgreementFootnoteProps } from './types';

const LegalAgreementFootnote = ({
  introText,
  termsLabel,
  conjunctionText,
  privacyLabel,
  onTermsPress,
  onPrivacyPress,
}: LegalAgreementFootnoteProps) => {
  // Two deterministic centered lines: the intro on line 1, the legal links on
  // line 2 (always). Links are inline <Text onPress> segments (not nested
  // <Pressable>) so they flow inline and share the text baseline — a
  // <Pressable> is a View, which native cannot lay out inside <Text> and which
  // previously broke the sentence flow and vertical centering. Each line is
  // centered and wraps responsively if the sheet is unusually narrow.
  return (
    <VStack style={styles.container}>
      <Text variant="s" color="textTertiary" align="center">
        {introText}
      </Text>
      <Text variant="s" color="textTertiary" align="center">
        <Text
          variant="s"
          color="textPrimary"
          style={styles.legalLink}
          onPress={onTermsPress}
          accessibilityRole="link"
        >
          {termsLabel}
        </Text>{' '}
        {conjunctionText}{' '}
        <Text
          variant="s"
          color="textPrimary"
          style={styles.legalLink}
          onPress={onPrivacyPress}
          accessibilityRole="link"
        >
          {privacyLabel}
        </Text>
        .
      </Text>
    </VStack>
  );
};

LegalAgreementFootnote.displayName = 'LegalAgreementFootnote';
export { LegalAgreementFootnote };
